import { Dialog } from "primereact/dialog";
import React from "react";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import styled from "styled-components";
import { PaediaMultipleChoiceElementPart_SubmittedAnswersQuery } from "@generated/PaediaMultipleChoiceElementPart_SubmittedAnswersQuery.graphql";
import { SUBMITTED_ANSWERS_QUERY } from "./PaediaMultipleChoiceElementPart.component";
import { CustomButtonDialog } from "../../../infecto-lms-webapp/components/buttons/CustomButtonDialog";
import { PrimaryButton } from "../../../infecto-lms-webapp/components/buttons/PrimaryButton";
import { SecondaryButton } from "../../../infecto-lms-webapp/components/buttons/SecondaryButton";
import { StripHtml } from "../../../infecto-lms-webapp/functions/helpers/StripHtml";
import { LMS_WEBAPP_CONFIG_IMPL } from "../../../infecto-lms-webapp-impl/config";

interface OwnProps {
	isVisible: boolean;
	onHideDialog(): void;
	queryRef: PreloadedQuery<
		PaediaMultipleChoiceElementPart_SubmittedAnswersQuery,
		Record<string, unknown>
	>;
	submitLearnElement(): void;
	totalElementsCount: number;
	currentElement: any;
	checkedAnswerIndices: number[];
}

export function ShowUserAnswersSummaryDialog({
	isVisible,
	onHideDialog,
	queryRef,
	submitLearnElement,
	totalElementsCount,
	currentElement,
	checkedAnswerIndices,
}: OwnProps) {
	const data = usePreloadedQuery<PaediaMultipleChoiceElementPart_SubmittedAnswersQuery>(
		SUBMITTED_ANSWERS_QUERY,
		queryRef,
	);

	const answersRenderer = (answers: readonly string[]): JSX.Element[] => {
		return answers?.map((answer, index) => <p key={index}>{StripHtml(answer)}</p>);
	};

	const itemRenderer = (index: number, question: string, answers: JSX.Element[]): JSX.Element => {
		return (
			<div key={index}>
				<span className="font-bold text-sm md:text-base">
					<span>{index + 1}. Frage:</span> {StripHtml(question)}
				</span>
				<br />
				<br />
				<div className="flex flex-row">
					<p className="text-sm md:text-base">Ihre Antwort:</p>
					<div className="text-sm md:text-base ml-4 mb-2">{answers}</div>
				</div>
				<br />
			</div>
		);
	};

	const contentRenderer = data.LearnV2.GetSubmittedAnswers.map((decision, index) =>
		itemRenderer(index, decision.question, answersRenderer(decision.answers)),
	);

	if (data.LearnV2.GetSubmittedAnswers.length < totalElementsCount) {
		contentRenderer.push(
			itemRenderer(
				totalElementsCount - 1,
				currentElement?.question,
				answersRenderer(
					currentElement?.answerOptions
						.filter((e: any, index: number) => checkedAnswerIndices.includes(index))
						.map((e: any) => e.answer),
				),
			),
		);
	}

	const onSubmitLearnElementAndHideDialog = () => {
		submitLearnElement();
		onHideDialog();
	};

	const goBackButton = () => {
		onHideDialog();
		contentRenderer.pop();
	};
	const footer = () => {
		return (
			<div>
				<SecondaryButton label="Zurück" onClick={goBackButton} />
				<CustomButtonDialog
					color={LMS_WEBAPP_CONFIG_IMPL.brandColor}
					label="Absenden"
					onClick={onSubmitLearnElementAndHideDialog}
				/>
			</div>
		);
	};

	return (
		<StyledDialog
			header="Zusammenfassung der Anworten"
			visible={isVisible}
			footer={footer}
			onHide={onHideDialog}
		>
			{contentRenderer}
		</StyledDialog>
	);
}

const StyledDialog = styled(Dialog)`
	width: 70%;
	@media (max-width: 768px) {
		width: 90%;
	}
`;
